module.exports = __webpack_public_path__ + "media/images/top/img_interview_yuakasaka-92f04961973f1ffb2a62b292d779a383.jpg";